'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

EditOrganizationUserModalController=(_dec=



























































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class EditOrganizationUserModalController extends BaseController{static get $inject(){return['$modalInstance','$modal','user','userService','socketService','uiCommandFactory','onUserUpdated','uncaughtErrorHandler']}constructor($modalInstance,$modal,user,userService,socketService,uiCommandFactory,onUserUpdated,uncaughtErrorHandler){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._$modal=$modal;this._socketService=socketService;this._onUserUpdated=onUserUpdated;this._editUserCommand=uiCommandFactory.makeForModal($modalInstance,this._editCurrentUser.bind(this));this.emailErrorHandler=this.emailErrorHandler.bind(this);this._user=user;this._firstName=user.firstName;this._lastName=user.lastName;this._email=user.email;this._phone=user.phone;this._role=user.role;this._isPrimary=user.isPrimary;this._isEditingSelf=this._email===_.get(userService,'currentUser.email')}deleteUser(){this._$modalInstance.close();this._$modal.open({templateUrl:'/templates/features/organizationUsers/components/deleteUserModalView',controller:'DeleteUserModalController as controller',windowClass:'delete-user',resolve:{user:()=>this._user,onUserDeleted:()=>this._onUserUpdated}})}onCancel(){this._$modalInstance.dismiss()}get editUserCommand(){return this._editUserCommand}get submissionResult(){return this._submissionResult}emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===409){return`Email address "${this.email}" is already in use.`}}}
async _editCurrentUser(){
let editResult=await this._socketService.sendAndWaitForResponse('EditUser',{
id:this._user.id.toString(),
firstName:this._firstName,
lastName:this._lastName,
email:this._email,
phone:this._phone,
role:this._role});


this._submissionResult=editResult;

if(!SocketResponse.succeeded(editResult)){
return ModalSubmissionResult.KeepOpen;
}

await this._onUserUpdated();

return ModalSubmissionResult.Close();
}

get firstName(){
return this._firstName;
}

set firstName(firstName){
this._firstName=firstName;
}

get lastName(){
return this._lastName;
}

set lastName(lastName){
this._lastName=lastName;
}

get email(){
return this._email;
}

set email(email){
this._email=email;
}

get phone(){
return this._phone;
}

set phone(phone){
this._phone=phone;
}

get role(){
return this._role;
}

set role(role){
this._role=role;
}

get isPrimary(){
return this._isPrimary;
}

get isEditingSelf(){
return this._isEditingSelf;
}},(_applyDecoratedDescriptor(_class.prototype,'_editCurrentUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_editCurrentUser'),_class.prototype)),_class));


module.exports=EditOrganizationUserModalController;
//# sourceMappingURL=editOrganizationUserModalController.js.map
